import React, { useState, useEffect } from "react";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../HandleAPICalls/actions";
import ComboListComponent from "./component";
import { useParams } from "react-router-dom";


const ComboListContainer = (props) => {
  const { comboId } = useParams();
  const [combos, setCombos] = useState([]);
  const [filteredCombos, setFilteredCombos] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [comboStatusFilter, setComboStatusFilter] = useState([]);
  const [sortOption, setSortOption] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCombos();
  }, []);

  const fetchCombos = () => {
    setLoading(true);
    props.getDataFromAPI(
      `/partner/api/v2/combo/all`,
      "GET",
      undefined,
      (response) => {
        const normalizedData = response.map((combo) => ({
          ...combo,
          isActive: !!combo.isActive,
        }));
        setCombos(normalizedData);
        setFilteredCombos(normalizedData);
        setLoading(false);
      },
      (err) => {
        console.log("API Error:", err);
        toastr.error("Error", err.status.message);
        setLoading(false);
      }
    );
  };

  const SearchCombosApi = (query) => {
    const normalizedQuery = String(query || "").trim();
  
    if (!normalizedQuery) {
      setFilteredCombos(combos);
      return;
    }
  
    props.getDataFromAPI(
     `/partner/api/v2/combo/all/?searchQuery=${normalizedQuery.replace(/ /g, " ")}`,
      "GET",
      undefined,
      (response) => {
        const normalizedData = response.map((combo) => ({
          ...combo,
          isActive: !!combo.isActive,
        }));
        setFilteredCombos(normalizedData);
        setLoading(false);
      },
      (err) => {
        console.log("API Error:", err);
        toastr.error("Error", err.status.message);
        setLoading(false);
      }
    );
  };
  

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    SearchCombosApi(value);
  };
 
  useEffect(() => {
    handleSearchAndFilter();
  }, [searchTerm, comboStatusFilter, sortOption]);

  const toggleComboStatusFilter = (status) => {
    setComboStatusFilter((prevFilter) =>
      prevFilter.includes(status)
        ? prevFilter.filter((item) => item !== status)
        : [...prevFilter, status]
    );
  };

  // const handleSearchAndFilter = () => {
  //   let filtered = combos;

  //   filtered = filtered.filter((combo) => {
  //     const matchesSearch =
  //       combo.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //       combo.id.toString().includes(searchTerm.toLowerCase());
  //     return matchesSearch;
  //   });

  //   if (comboStatusFilter.length > 0) {
  //     filtered = filtered.filter((combo) => {

  //       const comboStatus = combo.isActive ? "Active" : "Inactive";
  //       return comboStatusFilter.includes(comboStatus);
  //     });
  //   }

  //   if (sortOption === "aToZ") {
  //     filtered = filtered.sort((a, b) => a.name.localeCompare(b.name));
  //   } else if (sortOption === "zToA") {
  //     filtered = filtered.sort((a, b) => b.name.localeCompare(a.name));
  //   } else if (sortOption === "priceLowToHigh") {
  //     filtered = filtered.sort((a, b) => a.total_price - b.total_price);
  //   } else if (sortOption === "priceHighToLow") {
  //     filtered = filtered.sort((a, b) => b.total_price - a.total_price);
  //   }

  //   setFilteredCombos(filtered);
  // };

  const handleSearchAndFilter = () => {
    let filtered = combos;

    const normalizedSearchTerm = String(searchTerm || "").toLowerCase();

    filtered = filtered.filter((combo) => {
      const matchesSearch =
        combo.name.toLowerCase().includes(normalizedSearchTerm) ||
        combo.id.toString().includes(normalizedSearchTerm);
      return matchesSearch;
    });

    if (comboStatusFilter.length > 0) {
      filtered = filtered.filter((combo) => {
        const comboStatus = combo.isActive ? "Active" : "Inactive";
        return comboStatusFilter.includes(comboStatus);
      });
    }

    if (sortOption === "aToZ") {
      filtered = filtered.sort((a, b) => a.name.localeCompare(b.name));
    } else if (sortOption === "zToA") {
      filtered = filtered.sort((a, b) => b.name.localeCompare(a.name));
    } else if (sortOption === "priceLowToHigh") {
      filtered = filtered.sort((a, b) => a.total_price - b.total_price);
    } else if (sortOption === "priceHighToLow") {
      filtered = filtered.sort((a, b) => b.total_price - a.total_price);
    }

    setFilteredCombos(filtered);
  };

  const handleClearAllFilter = () => {
    setSearchTerm("");
    setComboStatusFilter([]);
    setSortOption("");
    setFilteredCombos(combos);
  };

  return (
    <ComboListComponent
      loading={loading}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      comboStatusFilter={comboStatusFilter}
      setComboStatusFilter={setComboStatusFilter}
      combos={filteredCombos}
      sortOption={sortOption}
      setSortOption={setSortOption}
      toggleComboStatusFilter={toggleComboStatusFilter}
      handleClearAllFilter={handleClearAllFilter}
      SearchCombosApi={SearchCombosApi}
      handleSearchChange={handleSearchChange}
    />
  );
};

function mapStateToProps(props) {
  return {
    props,
  };
}

export default connect(mapStateToProps, {
  getDataFromAPI,
})(ComboListContainer);
